import React, { memo, useEffect, useState } from 'react';
import '../../css/ApplicationForm.css'; // Import your CSS file for styling
import logogeorgia from '../../assets/images/georgia.png'
import Button from '../../components/common/ui/Button';
import { RequestsActions } from '../../_store/Requests.slice';
import { useDispatch, useSelector } from 'react-redux';
import CustomModal from '../../components/common/CustomModal ';
import CustomInput from '../../components/common/RequestFormInput';
import SelectInput from '../../components/common/ui/Inputs/SelectInput'
import RadioButtonGroup from '../../components/common/ui/Inputs/RadioInput';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import SignatureField from '../../components/common/SignatureField';
import ApplicationFormSchema from '../../validation/ApplicationFormSchema';
import CheckBoxInput from '../../components/common/ui/Inputs/CheckBoxInput';
import NotesModal from './NotesModal';
import ApplicationCRISPFormSchema from '../../validation/ApplicationCRISPFormSchema';
import TranslateFile from '../../Loc/TranslateFile';
import { getStoredValue } from "../../_helpers/storageHelper";
import PublicDefenderServiceFormSchema from '../../validation/PublicDefenderServiceFormSchema';
import Loader from '../../components/common/Loader';

const PublicDefenderServiceForm = ({ setisshowNotice, isshowNotice, selectformcategory, handleBack, isEdit, selectrowItem, setisshowFeedbackbtn }) => {
    const currentLang = TranslateFile()
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const { RequestPublicDefenderServicesCUDResponse, GetAllStatesDetails, LoadRelationshipsResponse, GetInmateDetailsPDRequestResponse } = useSelector(state => state.Requests);
    const { GenderOptions, MaritalStatusOptions, YesorNoOptions, IncomeTypeOptions, FrequencyTYpeOptions } = useSelector(state => state?.dropdownOptions)
    // State to manage the form data
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const nameParts = storedloginResponse?.InmateFullName.trim().split(' ');
    const [isshowUpdatebtn, setisshowUpdatebtn] = useState(false);
    const [ssnishoworhide, setssnishoworhide] = useState({
        ishidessn1: true,
        ishidessn2: true,
        ishidessn3: true
    });
    const initialFormData = {
        formTitle: "",
        countyName: "",
        applicationYear: new Date().getFullYear(),
        applicationMonth: String(new Date().getMonth() + 1).padStart(2, '0'),
        applicationDay: String(new Date().getDate()).padStart(2, '0'),
        arrestYear: "",
        arrestMonth: "",
        arrestDay: "",
        offenseYear: "",
        offenseMonth: "",
        offenseDay: "",
        courtYear: "",
        courtMonth: "",
        courtDay: "",
        firstName: nameParts.length > 1 ? nameParts[nameParts.length - 1] : '',
        middleName: "",
        lastName: nameParts[0] || "",
        otherNames: "",
        caseNumber: "",
        charges: "",
        AuthorizationCharges: '',
        coDefendants: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        homePhone: "",
        cellPhone: "",
        workPhone: "",
        dobYear: "",
        dobMonth: "",
        dobDay: "",
        ssnFirst: "",
        ssnSecond: "",
        ssnThird: "",
        race: "",
        gender: "",
        guardianName: "",
        guardianTelephone: "",
        guardianAddress: "",
        maritalStatus: '',
        spouseName: "",
        spouseEmployed: '',
        spouseEmployedWhere: "",
        spouseIncome: "",
        incomeType: '',
        childrenAges: "",
        dependents: "",
        employed: '',
        employerDetails: "",
        jobTitle: "",
        lengthOfJob: "",
        priorEmployment: "",
        netIncome: "",
        netIncomeType: "",
        childSupportObligation: '',
        childSupportObligationType: "",
        incomeInJail: '',
        incomeInJailAmount: '',
        acknowledgeMent: false,
        receivesChildSupport: '',
        childSupportAmount: '',
        receivesWorkCompensation: '',
        workCompensationAmount: '',
        receivesBenefits: '',
        benefitsAmount: '',
        isDisabled: '',
        disabilityType: "",
        claimsAsDependent: '',
        dependentName: "",
        otherPayments: "",
        cashValue: "",
        vehicleModel: "",
        vehicleEstValue: "",
        realEstate: '',
        equityValue: "",
        otherAssets: '',
        courtOrderedPayment: "",
        unusualExpenses: "",
        signature: "",
        TotalBondAmount: "",
        PostYourBond: "",
        BondPersonAddressPhone: "",
        caseTotal: "",
        assistanceName: "",
        assistancePhone: "",
        assistanceAddress: "",
        facilityName: "",
        caseNo: "",
        AuthorizationName1: "",
        AuthorizationNumber1: "",
        AuthorizationRelationship1: "",
        AuthorizationName2: "",
        AuthorizationNumber2: "",
        AuthorizationRelationship2: "",
        AuthorizationName3: "",
        AuthorizationNumber3: "",
        AuthorizationRelationship3: "",
        otherRelation1: "",
        otherRelation2: "",
        otherRelation3: "",
        PDSClientDescription: "",
        clientSignature: "",
        witnessSignature: "",
        court: "",
        NamePayYourExpense: ""
    };
    const [formData, setFormData] = useState(initialFormData);
    const [isDisabled, setisDisabled] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setmodalContent] = useState("");
    const [modalContentColor, setmodalContentColor] = useState("");
    const [issubmit, setissubmit] = React.useState(false);
    const [currentField, setCurrentField] = useState('');
    const [values, setValues] = useState();
    const [showBoard, setShowBoard] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});
    const [notesData, setnotesData] = useState([]);
    const [isloading, setisloading] = useState(false);


    const firstkeyboardFields = ["countyName", "charges", "address", "city",
        "zip", "homePhone", "cellPhone", "workPhone", "ssnFirst",
        "ssnSecond", "ssnThird", "race", "guardianName", "guardianTelephone", "guardianAddress", "spouseName",
        "spouseIncome", "childrenAges", "dependents", "employerDetails", "jobTitle", "lengthOfJob",
        "netIncome",]

    const secoundkeyboardFields = ["otherPayments", "cashValue", "vehicleModel",
        "otherAssets", "courtOrderedPayment", "unusualExpenses", "TotalBondAmount",
        "PostYourBond", "BondPersonAddressPhone", "caseTotal",
        "assistanceName", "assistancePhone", "assistanceAddress", "facilityName",
        "caseNo", "AuthorizationCharges", "AuthorizationName1", "AuthorizationNumber1", "AuthorizationName2", "AuthorizationNumber2",
        "AuthorizationName3", "AuthorizationNumber3", "PDSClientDescription"]


    const [keyboardFields, setkeyboardFields] = useState([...firstkeyboardFields, ...secoundkeyboardFields]);

    const [requireFields, setrequireFields] = useState(["countyName", "address", "city", "zip", "ssnFirst", "ssnSecond", "ssnThird",
        "guardianName", "guardianAddress",
        "netIncome", "facilityName", "caseNo", "AuthorizationCharges", "guardianAddress",
    ]);

    const pdsfields = ["countyName", "charges", "address", "city", "State",
        "zip", "homePhone", "cellPhone", "workPhone", "ssnFirst",
        "ssnSecond", "ssnThird", "race", "guardianName", "guardianTelephone", "guardianAddress", "Marital", "spouseName", "isspouseEmp",
        "IsEmployee", "employerDetails", "jobTitle", "lengthOfJob",
        "netIncome", "incomeWeak", "childSupportObligation", "incomeInJail", "incomeInJailAmount", "isDisabled", "disabilityType", "claimsAsDependent",
        "supportAmountweak", "isworkCompAmount", "workCompAmount", "benefitsAmount", "receivesBenefits", "istax", "isdependentName", "otherPayments", "cashValue",
        "realEstate", "isreal", "otherAssets", "courtOrderedPayment", "unusualExpenses", "Sign", "TotalBondAmount",
        "caseTotal",
        "sign", "assistanceName", "assistancePhone", "assistanceAddress"]


    const [allFields, setallFields] = useState([...pdsfields]);


    const placeholder = {
        arrestMonth: "MM", arrestDay: "DD", arrestYear: "YYYY", offenseMonth: "MM", offenseDay: "DD", offenseYear: "YYYY",
        court: currentLang?.ApplicationFormPlaceholder?.Court_Name, countyName: currentLang?.ApplicationFormPlaceholder?.Country_Name, courtMonth: "MM", courtDay: "DD", courtYear: "YYYY",
        otherNames: currentLang?.ApplicationFormPlaceholder?.Example_Names, caseNumber: "Eg: 1234, 4568, 5555,.....", charges: "Eg: 4524585",
        coDefendants: currentLang?.ApplicationFormPlaceholder?.Example_Sam, address: currentLang?.ApplicationFormPlaceholder?.Example_Jack, city: currentLang?.ApplicationFormPlaceholder?.Example_Facility, zip: "Eg: 14856", homePhone: "Eg: 9999999999",
        cellPhone: "Eg: 9999999999", workPhone: "Eg: 9999999999", ssnFirst: "000", ssnSecond: "00", ssnThird: "0000", race: currentLang?.ApplicationFormPlaceholder?.Example_Race,
        guardianName: currentLang?.ApplicationFormPlaceholder?.Example_Mathew, guardianTelephone: "Eg: 9999999999", guardianAddress: currentLang?.ApplicationFormPlaceholder?.Example_Address,
        spouseName: currentLang?.ApplicationFormPlaceholder?.Example_John, spouseIncome: "Eg: 4500", childrenAges: "Eg: 11, 25, 05,...",
        dependents: currentLang?.ApplicationFormPlaceholder?.Example_Names, employerDetails: currentLang?.ApplicationFormPlaceholder?.Employee_Details, jobTitle: currentLang?.ApplicationFormPlaceholder?.Software_Developer,
        lengthOfJob: "Eg: 3", priorEmployment: "Eg: 01/25/2018 - $3500", netIncome: "Eg: 9999", supportAmount: "Eg: 9999", workCompAmount: "Eg: 9999",
        benefitsAmount: "Eg: 9999", NamePayYourExpense: currentLang?.ApplicationFormPlaceholder?.Cousin, vehicleModel: currentLang?.ApplicationFormPlaceholder?.Vechicle_Model, PDSClientDescription: currentLang?.ApplicationFormPlaceholder?.DESCRIPTION, AuthorizationNumber3: "Eg: 123456", AuthorizationName3: currentLang?.ApplicationFormPlaceholder?.Example_John,
        AuthorizationNumber2: "Eg: 123456", AuthorizationName2: currentLang?.ApplicationFormPlaceholder?.Example_John, AuthorizationNumber1: "Eg: 123456",
        AuthorizationName1: currentLang?.ApplicationFormPlaceholder?.Example_John, AuthorizationCharges: "Eg: 452648", caseNo: "Eg: 123456", facilityName: currentLang?.ApplicationFormPlaceholder?.Example_Facility,
        assistanceAddress: currentLang?.ApplicationFormPlaceholder?.Address, assistancePhone: "Eg: 0123456789", assistanceName: currentLang?.ApplicationFormPlaceholder?.John_Peter,
        submitterName: currentLang?.ApplicationFormPlaceholder?.John_Peter, caseTotal: "Eg: 7895", BondPersonAddressPhone: currentLang?.ApplicationFormPlaceholder?.Address,
        PostYourBond: currentLang?.ApplicationFormPlaceholder?.Example_John, TotalBondAmount: "5684", unusualExpenses: currentLang?.ApplicationFormPlaceholder?.Medicine, courtOrderedPayment: "Eg: 2586",
        otherAssets: "Eg: 2586", vehicleModel: currentLang?.ApplicationFormPlaceholder?.Vechicle_Model,
        cashValue: "Eg: 01234", otherPayments: currentLang?.ApplicationFormPlaceholder?.Field_work, disabilityType: currentLang?.ApplicationFormPlaceholder?.HandiCapped,
        benefitsAmount: "Eg: 9999", workCompensationAmount: "Eg: 9999", childSupportAmount: "Eg: 9999",
        incomeInJailAmount: "Eg: 9999", childSupportObligation: "Eg: 9999", priorEmployment: "Eg: 01/25/2018 - $3500",
        lengthOfJob: "Eg: 3", jobTitle: currentLang?.ApplicationFormPlaceholder?.Software_Developer, employerDetails: currentLang?.ApplicationFormPlaceholder?.Employee_Details, otherRelation1: currentLang?.ApplicationFormPlaceholder?.Friend,
        otherRelation2: currentLang?.ApplicationFormPlaceholder?.Friend, otherRelation3: currentLang?.ApplicationFormPlaceholder?.Friend,
    }

    const { GetInmateRequestPublicDefenderResponse } = useSelector(state => state.Requests);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isEdit && GetInmateDetailsPDRequestResponse?.length > 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                dobYear: GetInmateDetailsPDRequestResponse[0]?.DOB ? GetInmateDetailsPDRequestResponse[0]?.DOB.split('/')[2] : '',
                dobMonth: GetInmateDetailsPDRequestResponse[0]?.DOB ? GetInmateDetailsPDRequestResponse[0]?.DOB?.split('/')[0] : '',
                dobDay: GetInmateDetailsPDRequestResponse[0]?.DOB ? GetInmateDetailsPDRequestResponse[0]?.DOB?.split('/')[1] : '',
                Gender: GetInmateDetailsPDRequestResponse[0]?.Gender == "Unknown" ? '3' : '3'
            }));
        }
    }, [isEdit, GetInmateDetailsPDRequestResponse])

    useEffect(() => {
        if (isEdit) {
            if (selectrowItem?.RequestFormType) {
                setisloading(true);
                dispatch(RequestsActions.GetInmateRequestPublicDefender(selectrowItem?.RequestFormTypeID)).then(x => {
                    setisloading(false);
                    if ((x?.payload[0].IsInmateReSubmited == 1) || (x?.payload[0].IsPdStaffReSubmited == 0) || (x?.payload[0].IsFormApprovedPdStaff == 1) || (x?.payload[0].PdsFormStatus == "Closed")) {
                        setisDisabled(true);
                    }
                    else { setisshowUpdatebtn(true); }
                    if (x?.payload[0]?.IsPdsServicesNotesExists == 1) {
                        setisshowFeedbackbtn(true);
                        dispatch(RequestsActions.LoadInmateRequestPdsNotesDetails(selectrowItem?.RequestFormTypeID)).then(x => {
                            if (x?.payload?.length > 0)
                                setnotesData(x?.payload);
                        })
                    }
                })
            }
        }
    }, [isEdit]);

    useEffect(() => {
        if (isshowUpdatebtn) {
            setFormData((prev) => ({
                ...prev,
                acknowledgeMent: false, pdsInmateSignature: '', clientSignature: ''
            }));
        }
    }, [isshowUpdatebtn])

    useEffect(() => {
        if (isEdit && GetInmateRequestPublicDefenderResponse.length > 0) {
            const data = GetInmateRequestPublicDefenderResponse[0];
            setFormData({
                formTitle: data.PdsFormTitle || '',
                applicationMonth: data.ApplicationData ? data.ApplicationData?.split('/')[0] : '',
                applicationDay: data.ApplicationData ? data.ApplicationData?.split('/')[1] : '',
                applicationYear: data.ApplicationData ? data.ApplicationData?.split('/')[2] : '',
                arrestMonth: data.DataOfArrest ? data.DataOfArrest?.split('/')[0] : '',
                arrestDay: data.DataOfArrest ? data.DataOfArrest?.split('/')[1] : '',
                arrestYear: data.DataOfArrest ? data.DataOfArrest?.split('/')[2] : '',
                offenseMonth: data.DateOfOffense ? data.DateOfOffense?.split('/')[0] : '',
                offenseDay: data.DateOfOffense ? data.DateOfOffense?.split('/')[1] : '',
                offenseYear: data.DateOfOffense ? data.DateOfOffense?.split('/')[2] : '',
                courtMonth: data.CourtDate ? data.CourtDate?.split('/')[0] : '',
                courtDay: data.CourtDate ? data.CourtDate?.split('/')[1] : '',
                courtYear: data.CourtDate ? data.CourtDate?.split('/')[2] : '',
                lastName: data.LastName || '',
                PDSClientDescription: data?.PDSClientDescription || '',
                court: data.Court || '',
                firstName: data.FirstName || '',
                middleName: data.MiddleName || '',
                otherNames: data.OtherNames || '',
                caseNumber: data.CaseNumber || '',
                charges: data.Charges || '',
                AuthorizationCharges: data.AuthorizationCharges || '',
                TotalBondAmount: (data?.TotalBondAmount || 0)?.toFixed(2),
                PostYourBond: data?.PostYourBond || '',
                BondPersonAddressPhone: data?.BondPersonAddressPhone || '',
                coDefendants: data.CoDefendants || '',
                address: data.InmateAddress || '',
                city: data.City || '',
                state: parseInt(data.StateName) || '',
                zip: data.Zip || '',
                homePhone: data.HomePhone || '',
                cellPhone: data.CellPhone || '',
                workPhone: data.WorkPhone || '',
                dobMonth: data.DOB ? data.DOB?.split('/')[0] : '',
                dobDay: data.DOB ? data.DOB?.split('/')[1] : '',
                AutorizationMonth: data?.AutorizationDate?.split(',')[1]?.trim() || '',   // Extracts and trims the month
                AutorizationDay: data?.AutorizationDate?.split(',')[0]?.split(' ')[0] || '',  // Extracts the day and removes any suffix like "th"
                AutorizationYear: data?.AutorizationDate?.split(',')[2]?.trim() || '',
                dobYear: data.DOB ? data.DOB?.split('/')[2] : '',
                ssnFirst: data.SSN ? data.SSN?.split('-')[0] : '',
                ssnSecond: data.SSN ? data.SSN?.split('-')[1] : '',
                ssnThird: data.SSN ? data.SSN?.split('-')[2] : '',
                race: data.Race || '',
                Gender: data.Gender || "3",
                guardianName: data.EmergContactPerson || '',
                guardianPhone: data.EmergContactPhone || '',
                guardianAddress: data.EmergContactAddress || '',
                maritalStatus: data.MaritalStatus || '',
                spouseName: data.SpousesName || '',
                spouseEmployed: data.IsSpousesEmployed || 0,
                spouseWorkLocation: data.SpousesWorkLocation || '',
                spouseIncome: JSON.stringify(data.SpousesIncome) || '',
                incomeType: data.SpousesIncomeCycle || '',
                childrenAges: data.ChildrenAges || '',
                dependents: data.OtherDependents || '',
                employed: data.IsInmateEmployed || 0,
                employerDetails: data.EmployerDetails || '',
                jobTitle: data.JobTitle || '',
                lengthEmployment: data.LengthEmployment || '',
                previousEmployment: data.PreviousEmpoyment || '',
                netIncome: (data?.InmateNetIncome || 0)?.toFixed(2),
                netIncomeType: data.InmateIncomeCycle || 0,
                childSupportObligation: data?.ChildSupportObligation == 0 ? '' : (data?.ChildSupportObligation || 0)?.toFixed(2),
                childSupportCycle: data.ChildSupportObligationCycle || 0,
                jailIncome: data.JailIncome || 0,
                caseNo: data?.CaseNo,
                jailIncomeEnabled: data.IsJailIncome || 0,
                receiveChildSupport: data.IsReceiveChildSupport || 0,
                receiveChildAmount: data.ReceiveChildAmount || 0,
                workCompensation: data.IsReceiveCompensation || 0,
                compensationAmount: data.CompensationAmount || 0,
                AuthorizationName1: data.AuthorizationName1 || '',
                AuthorizationNumber1: data.AuthorizationNumber1 || '',
                AuthorizationRelationship1: data.AuthorizationRelationship1 == '0' ? '' : ['1', '2', '3', '4', '5'].includes(data.AuthorizationRelationship1) ? parseInt(data.AuthorizationRelationship1 || '') : 6,
                otherRelation1: data.AuthorizationRelationship1 == '0' ? '' : ['1', '2', '3', '4', '5'].includes(data.AuthorizationRelationship1) ? "" : data.AuthorizationRelationship1,
                AuthorizationName2: data.AuthorizationName2 || '',
                AuthorizationNumber2: data.AuthorizationNumber2 || '',
                AuthorizationRelationship2: data.AuthorizationRelationship2 == '0' ? '' : ['1', '2', '3', '4', '5'].includes(data.AuthorizationRelationship2) ? parseInt(data.AuthorizationRelationship2 || '') : 6,
                otherRelation2: data.AuthorizationRelationship2 == '0' ? '' : ['1', '2', '3', '4', '5'].includes(data.AuthorizationRelationship2) ? "" : data.AuthorizationRelationship2,
                AuthorizationName3: data.AuthorizationName3 || '',
                AuthorizationNumber3: data.AuthorizationNumber3 || '',
                AuthorizationRelationship3: data.AuthorizationRelationship3 == '0' ? '' : ['1', '2', '3', '4', '5'].includes(data.AuthorizationRelationship3) ? parseInt(data.AuthorizationRelationship3 || '') : 6,
                otherRelation3: data.AuthorizationRelationship3 == '0' ? '' : ['1', '2', '3', '4', '5'].includes(data.AuthorizationRelationship3) ? "" : data.AuthorizationRelationship3,
                clientSignature: data?.ClientSignature || '',
                pdsInmateSignature: isshowUpdatebtn ? "" : data?.InmateSignature || "",
                signature: data?.NotDesireServicesSign || "",
                courtOrderedPayment: data?.CourtOrderMonthlyPayment == 0 ? '' : (data?.CourtOrderMonthlyPayment || 0)?.toFixed(2),
                unusualExpenses: data?.UnusualExpenseTypeAmount,
                otherAssets: data?.OtherAssetsOrPropertyDetails || 0,
                equityValue: data?.EquityShareAmount == 0 ? '' : (data?.EquityShareAmount || 0)?.toFixed(2),
                realEstate: data?.IsAnyRealEstateInYourName || 0,
                vehicleEstValue: data?.MotorVehiclesEstValue == 0 ? '' : (data?.MotorVehiclesEstValue || 0)?.toFixed(2),
                vehicleModel: data?.MotorVehiclesDetails,
                otherPayments: data?.OtherPaymentSource,
                dependentName: data?.ClaimDependentNameForTax,
                claimsAsDependent: data?.IsClaimDependentForTax,
                disabilityType: data?.TypeOfDisability,
                isDisabled: data?.IsInmateDisabled,
                NamePayYourExpense: data?.NamePayYourExpense,
                benefitsAmount: data?.OtherBenefitsAmount == 0 ? '' : (data?.OtherBenefitsAmount || 0)?.toFixed(2),
                receivesBenefits: data?.IsReceiveOtherBenefits,
                workCompensationAmount: data?.CompensationAmount == 0 ? '' : (data?.CompensationAmount || 0)?.toFixed(2),
                receivesWorkCompensation: data?.IsReceiveCompensation,
                childSupportAmount: data?.ReceiveChildAmount == 0 ? '' : (data?.ReceiveChildAmount || 0)?.toFixed(2),
                receivesChildSupport: data?.IsReceiveChildSupport,
                incomeInJailAmount: data?.IsJailIncome == 0 ? '' : (data?.IsJailIncome || 0)?.toFixed(2),
                incomeInJail: data?.IsInJail,
                priorEmployment: data?.PreviousEmpoyment, lengthOfJob: data?.LengthEmployment,
                guardianTelephone: data?.EmergContactPhone,
                acknowledgeMent: isshowUpdatebtn ? false : true,
                countyName: data?.FacilityName,
                cashValue: data?.InmateLiquidAsset == 0 ? '' : (data?.InmateLiquidAsset || 0)?.toFixed(2),
                caseTotal: data?.ApplicationCaseDetails,
                facilityName: data?.PendingCaseFacility,
                childSupportObligationType: data?.ChildSupportObligationCycle == 0 ? '' : data?.ChildSupportObligationCycle,
                spouseEmployedWhere: data?.SpousesWorkLocation,
                assistanceName: data?.DefendantAssistanceName,
                assistancePhone: data?.DefendantAssistancePhone,
                assistanceAddress: data?.DefendantAssistanceAddress

            });
        }
    }, [GetInmateRequestPublicDefenderResponse]);

    useEffect(() => {
        if (issubmit && RequestPublicDefenderServicesCUDResponse?.length != 0) {
            switch (RequestPublicDefenderServicesCUDResponse) {
                case 1:
                    setmodalContent(currentLang?.AlertPopup?.Form_Submit_Success); setmodalContentColor('#4a9a93'); setShowPopup(true)
                    break;
                case 2:
                    setmodalContent(currentLang?.AlertPopup?.Form_Updated_Success); setmodalContentColor('#4a9a93'); setShowPopup(true)
                    break;
                case 0:
                case -1:
                    setmodalContent(currentLang?.AlertPopup?.Operation_Failed); setmodalContentColor('#c8605e'); setShowPopup(true)
                    break;

            }


        }
    }, [RequestPublicDefenderServicesCUDResponse]);

    useEffect(() => {
        dispatch(RequestsActions.loadGetAllStates());
        dispatch(RequestsActions.LoadRelationships());
    }, []);

    const ValidssnCheck = () => {
        const errors = [];
        if (formData?.ssnFirst?.trim()?.length !== 3) {
            errors.push(currentLang?.ValidationSchema?.Form_Field_Required);
            setErrorMessage((prev) => ({
                ...prev,
                ssnFirst: currentLang?.ValidationSchema?.Form_Field_Required,
            }));
        }
        if (formData?.ssnSecond?.trim()?.length !== 2) {
            errors.push(currentLang?.ValidationSchema?.Form_Field_Required);
            setErrorMessage((prev) => ({
                ...prev,
                ssnSecond: currentLang?.ValidationSchema?.Form_Field_Required,
            }));
        }
        if (formData?.ssnThird?.trim()?.length !== 4) {
            errors.push(currentLang?.ValidationSchema?.Form_Field_Required);
            setErrorMessage((prev) => ({
                ...prev,
                ssnThird: currentLang?.ValidationSchema?.Form_Field_Required,
            }));
        }
        return errors.length === 0; // Returns true if valid, false otherwise
    }

    const handleSubmit = () => {
        setErrorMessage({});
        // Validate Dates

        const { error } = selectformcategory == 63 ? PublicDefenderServiceFormSchema(formData) : ApplicationCRISPFormSchema(formData);
        let validationFailed = false;

        if (!ValidssnCheck()) {
            validationFailed = true;
        }

        if (error) {
            error.details.forEach((e) => {
                setErrorMessage((prev) => ({
                    ...prev,
                    [e.path.toString()]: e.message,
                }));
            });
            setmodalContent(currentLang?.AlertPopup?.Please_Fill_All_Fields);
            setShowPopup(true);
            validationFailed = true;
        }

        if (validationFailed) return;

        const defaultdate = new Date().toISOString()

        const requestData = {
            pdsRequestPublicDefenderServicesID: selectrowItem?.RequestFormTypeID ? selectrowItem?.RequestFormTypeID : 0,
            pdsFacilityID: storedloginResponse?.facilityID || 0,
            pdsInmateID: storedloginResponse?.InmateID || 0,
            podCode: storedLoginDetails?.PodCode || "",
            pdsRequestFormTypeID: selectformcategory,
            pdsPdsFormTitle: formData.formTitle || "",
            pdsCounty: formData?.countyName || "",
            pdsApplicationDate: (formData.applicationYear && formData.applicationMonth && formData.applicationDay)
                ? new Date(Date.UTC(formData.applicationYear, formData.applicationMonth - 1, formData.applicationDay))
                : defaultdate, // Defaults to now if no date is provided
            pdsDataOfArrest: (formData.arrestYear && formData.arrestMonth && formData.arrestDay)
                ? new Date(Date.UTC(formData.arrestYear, formData.arrestMonth - 1, formData.arrestDay))
                : defaultdate,
            pdsDateOfOffense: (formData.offenseYear && formData.offenseMonth && formData.offenseDay)
                ? new Date(Date.UTC(formData.offenseYear, formData.offenseMonth - 1, formData.offenseDay))
                : defaultdate,
            isInJail: 1,
            pdsCourt: formData.court || "", // Ensure this is initialized
            pdsCourtDate: (formData.courtYear && formData.courtMonth && formData.courtDay)
                ? new Date(Date.UTC(formData.courtYear, formData.courtMonth - 1, formData.courtDay))
                : defaultdate,
            pdsfirstName: formData.firstName || "",
            pdsMiddleName: formData.middleName || "",
            pdsLastName: formData.lastName || "",
            pdsOtherNames: formData.otherNames || "",
            pdsCaseNumber: formData.caseNumber || "",
            pdsCharges: formData.charges || "",
            pdsCoDefendants: formData.coDefendants || "",
            pdsInmateAddress: formData.address || "",
            pdsCity: formData.city || "",
            pdsStateName: formData.state || "",
            pdsZip: formData.zip || "",
            pdsHomePhone: formData.homePhone || "",
            pdsCellPhone: formData.cellPhone || "",
            pdsWorkPhone: formData.workPhone || "",
            pdsdob: (formData.dobYear && formData.dobMonth && formData.dobDay)
                ? `${formData.dobMonth}/${formData.dobDay}/${formData.dobYear}`
                : "",
            pdsssn: formData.ssnFirst && formData.ssnSecond && formData.ssnThird
                ? `${formData.ssnFirst}-${formData.ssnSecond}-${formData.ssnThird}`
                : "",
            pdsRace: formData.race || "",
            pdsGender: formData.Gender || "3",
            pdsEmergContactPerson: formData.guardianName || "",
            pdsEmergContactPhone: formData.guardianTelephone || "",
            pdsEmergContactAddress: formData.guardianAddress || "",
            pdsMaritalStatus: formData.maritalStatus || 0, // Ensure this is a number
            pdsSpousesName: formData.spouseName || "",
            pdsIsSpousesEmployed: formData.spouseEmployed ? 1 : 0,
            pdsSpousesWorkLocation: formData.spouseEmployedWhere || "",
            pdsSpousesIncome: formData.spouseIncome || 0,
            pdsSpousesIncomeCycle: formData.incomeType || 0, // Ensure this is a number
            pdsChildrenAges: formData.childrenAges || "",
            pdsOtherDependents: formData.dependents || "",
            pdsIsInmateEmployed: formData.employed ? 1 : 0,
            pdsEmployerDetails: formData.employerDetails || "",
            pdsJobTitle: formData.jobTitle || "",
            pdsLengthEmployment: formData.lengthOfJob || "",
            pdsPreviousEmpoyment: formData.priorEmployment || "",
            pdsInmateNetIncome: formData.netIncome || 0,
            pdsInmateIncomeCycle: formData.netIncomeType || 0, // Ensure this is a number
            pdsChildSupportIncome: formData.childSupportObligation || 0,
            pdsChildSupportCycle: formData.childSupportObligationType || 0, // Ensure this is a number
            pdsIsJailIncome: formData.incomeInJail || 1,
            pdsJailIncome: formData.incomeInJailAmount || 0,
            pdsIsReceiveChildSupport: formData.receivesChildSupport ? 1 : 0,
            pdsReceiveChildAmount: formData.childSupportAmount || 0,
            pdsIsReceiveCompensation: formData.receivesWorkCompensation ? 1 : 0,
            pdsCompensationAmount: formData.workCompensationAmount || 0,
            pdsIsReceiveOtherBenefits: formData.receivesBenefits || 0,
            pdsOtherBenefitsAmount: formData.benefitsAmount || 0,
            pdsNamePayYourExpense: formData.NamePayYourExpense || "",
            pdsIsInmateDisabled: formData.isDisabled || 0,
            pdsTypeOfDisability: formData.disabilityType || "",
            pdsIsClaimDependentForTax: formData.claimsAsDependent ? 1 : 0,
            pdsClaimDependentNameForTax: formData.dependentName || "",
            pdsOtherPaymentSource: formData.otherPayments || "",
            pdsInmateLiquidAsset: formData.cashValue || 0,
            pdsMotorVehiclesDetails: formData.vehicleModel || "",
            pdsMotorVehiclesEstValue: formData.vehicleEstValue || 0,
            pdsIsAnyRealEstateInYourName: formData.realEstate || 0,
            pdsEquityShareAmount: formData.equityValue || 0,
            pdsOtherAssetsOrPropertyDetails: formData.otherAssets || 0,
            pdsCourtOrderMonthlyPayment: formData.courtOrderedPayment || 0,
            pdsUnusualExpenseTypeAmount: formData.unusualExpenses || "",
            pdsNotDesireServicesDate: (formData.applicationYear && formData.applicationMonth && formData.applicationDay)
                ? new Date(Date.UTC(formData.applicationYear, formData.applicationMonth - 1, formData.applicationDay))
                : defaultdate,
            pdsTotalBondAmount: formData.TotalBondAmount || 0,
            pdsPostYourBond: formData.PostYourBond || "",
            pdsBondPersonAddressPhone: formData.BondPersonAddressPhone || "",
            pdsApplicationCaseDetails: formData.caseTotal || "",
            pdsAcknowledgeDate: new Date().toISOString() || "",
            pdsInmatePrintName: storedloginResponse?.InmateFullName || "",
            pdsDefendantAssistanceName: formData.assistanceName || "",
            pdsDefendantAssistancePhone: formData.assistancePhone || "",
            pdsDefendantAssistanceAddress: formData.assistanceAddress || "",
            pdsClientFacilityName: formData?.facilityName || "",
            pdsCaseNo: formData.caseNo || "",
            pdsClientCharges: formData.AuthorizationCharges || "",
            pdsClientName1: formData.AuthorizationName1 || "",
            pdsClientNumber1: formData.AuthorizationNumber1 || "",
            pdsClientRelationship1: formData.AuthorizationRelationship1 == 6 ? formData?.otherRelation1 : formData.AuthorizationRelationship1 || 0,
            pdsClientName2: formData.AuthorizationName2 || "",
            pdsClientNumber2: formData.AuthorizationNumber2 || "",
            pdsClientRelationship2: formData.AuthorizationRelationship2 == 6 ? formData?.otherRelation2 : formData.AuthorizationRelationship2 || 0,
            pdsClientName3: formData.AuthorizationName3 || "",
            pdsClientNumber3: formData.AuthorizationNumber3 || "",
            pdsClientRelationship3: formData.AuthorizationRelationship3 == 6 ? formData?.otherRelation3 : formData.AuthorizationRelationship3 || 0,
            pdsClientDescription: formData?.PDSClientDescription || "",
            pdsClientDate: new Date().toISOString() || "",
            pdsClientSignature: formData.clientSignature || "",
            pdsWitnessSignature: formData.witnessSignature || "",
            pdsInmateSignature: formData.pdsInmateSignature || "",
            pdsNotDesireServicesSign: formData.signature || "",
            pdsAction: selectrowItem?.RequestFormTypeID ? 2 : 1 // or another appropriate value
        };
        dispatch(RequestsActions.loadRequestPublicDefenderServicesCUD(requestData));
        setissubmit(true);
    };

    const handleFieldClick = (field) => {
        setCurrentField(field); setShowBoard(true); setValues(formData)
    }


    const renderPublicDefenderForm = () => {
        return (
            <>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <label className="form-label col-form-label w-100 fs-5 form-label-custom-visible" >1. {currentLang?.ApplicationForm?.Application_Date}</label>

                    <div className="d-inline-flex align-items-center">
                        <CustomInput
                            isShowError={false}
                            isdisabled={true}
                            type="text"
                            isDate={true}
                            id="txtPdSArrestMonth"
                            name="month"
                            className=""
                            value={formData.applicationMonth}
                            placeholder="MM"
                            onClick={() => handleFieldClick('applicationMonth')}
                        />
                        <span className="mx-1">/</span>
                        <CustomInput
                            isShowError={false}
                            isdisabled={true}
                            type="text"
                            isDate={true}
                            id={"txtPdSArrestDay"}
                            name="day"
                            className=""
                            value={formData.applicationDay}
                            placeholder="DD"
                            onClick={() => handleFieldClick('applicationDay')}
                        />
                        <span className="mx-1">/</span>
                        <CustomInput
                            isShowError={false}
                            isdisabled={true}
                            type="text"
                            isDate={true}
                            name="year"
                            id={"txtPdSArrestYear"}
                            value={formData.applicationYear}
                            placeholder="YYYY"
                            onClick={() => handleFieldClick('applicationYear')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            label={` 2. ${currentLang?.ApplicationForm?.County} `}
                            required={true}
                            isdisabled={isDisabled ? true : false}
                            type="text"
                            name="countyName"
                            value={formData.countyName}
                            errorMessage={errorMessage.countyName}
                            className="form-control pd-0"
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Country_Name}
                            onClick={() => handleFieldClick('countyName')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            label={` 3. ${"Last Name : "} `}
                            isdisabled={true}
                            type="text"
                            placeholder={currentLang?.ApplicationFormPlaceholder?.LastName}
                            value={formData.lastName}
                            onClick={() => handleFieldClick('lastName')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            isdisabled={true}
                            label={`${"First Name : "} `}
                            type="text"
                            placeholder={currentLang?.ApplicationFormPlaceholder?.FirstName}
                            value={formData.firstName}
                            onClick={() => handleFieldClick('firstName')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            isdisabled={true}
                            type="text"
                            label={`${"Middle Name : "} `}
                            placeholder="-"
                            value={formData.middleName}
                            onClick={() => handleFieldClick('middleName')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`4. ${currentLang?.ApplicationForm?.Charges}`}
                            type="text"
                            required={true}
                            placeholder="Eg: 4524585"
                            errorMessage={errorMessage.charges}
                            value={formData.charges}
                            onClick={() => handleFieldClick('charges')}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`5. ${currentLang?.ApplicationForm?.Address}`}
                            type="text"
                            required={true}
                            errorMessage={errorMessage.address}
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Example_Jack}
                            value={formData.address}
                            onClick={() => handleFieldClick('address')}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`6. ${currentLang?.ApplicationForm?.City}`}
                            type="text"
                            required={true}
                            errorMessage={errorMessage.city}
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Example_Facility}
                            value={formData.city}
                            onClick={() => handleFieldClick('city')}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <SelectInput
                            isShowError={false}
                            options={GetAllStatesDetails?.length > 0 ? GetAllStatesDetails : []}
                            label={`7. ${currentLang?.ApplicationForm?.State}`}
                            isDisabled={isDisabled ? true : false}
                            name="state"
                            id="state"
                            labelKey="label"
                            required={true}
                            height={'35px'}
                            valueKey="value"
                            value={formData.state}
                            errorMessage={errorMessage}
                            isClearable={false}
                            placeholder={currentLang?.placeholder?.Select}
                            handleChange={(e) => {
                                setFormData({ ...formData, ['state']: e.value });
                                setErrorMessage({ ...errorMessage, state: e.value ? '' : "This field is required" });
                            }}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group pd-0">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`8. ${currentLang?.ApplicationForm?.ZIP}`}
                            type="text"
                            required={true}
                            errorMessage={errorMessage?.zip}
                            placeholder="Eg: 14856"
                            value={formData.zip}
                            onClick={() => handleFieldClick('zip')}
                        />
                    </div>
                </div>
            </>
        )
    }

    const rendertelephoneForm = () => {
        return (
            <>
                <div className="col-md-12">
                    <h4 className="app-form-title"> {currentLang?.ApplicationForm?.TelePhone_No} </h4>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`9. ${currentLang?.ApplicationForm?.Home}`}
                            type="text"
                            placeholder="Eg: 9999999999"
                            value={formData.homePhone}
                            onClick={() => handleFieldClick('homePhone')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`10. ${currentLang?.ApplicationForm?.Cell}`}
                            type="text"
                            placeholder="Eg: 9999999999"
                            value={formData.cellPhone}
                            onClick={() => handleFieldClick('cellPhone')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`11. ${currentLang?.ApplicationForm?.Work}`}
                            type="text"
                            placeholder="Eg: 9999999999"
                            value={formData.workPhone}
                            onClick={() => handleFieldClick('workPhone')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible" >12. {currentLang?.ApplicationForm?.Date_of_Birth}</label>
                        <div className="d-inline-flex align-items-center">
                            <CustomInput
                                isShowError={false}
                                isdisabled={true}
                                name="dobMonth"
                                placeholder="MM"
                                value={formData.dobMonth}
                                onClick={() => handleFieldClick('dobMonth')}
                            />
                            <span className="mx-1">/</span>
                            <CustomInput
                                isShowError={false}
                                isdisabled={true}
                                name="dobDay"
                                placeholder="DD"
                                value={formData.dobDay}
                                onClick={() => handleFieldClick('dobDay')}
                            />
                            <span className="mx-1">/</span>
                            <CustomInput
                                isShowError={false}
                                isdisabled={true}
                                name="dobYear"
                                placeholder="YYYY"
                                value={formData.dobYear}
                                onClick={() => handleFieldClick('dobYear')}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">13. {currentLang?.ApplicationForm?.SSN}<span className="mandatory">*</span></label>
                        <div className="d-inline-flex align-items-center">
                            <CustomInput
                                isShowError={false}
                                isdisabled={isDisabled ? true : false}
                                placeholder="000"
                                errorMessage={errorMessage.ssnFirst}
                                value={formData.ssnFirst}
                                onClick={() => handleFieldClick('ssnFirst')}
                                type={ssnishoworhide?.ishidessn1 ? "password" : "text"}
                                togglePasswordVisibility={() => {
                                    setssnishoworhide(prevFormData => ({
                                        ...prevFormData,
                                        ishidessn1: !ssnishoworhide?.ishidessn1
                                    }))
                                }}
                            />
                            <span className='mx-1'>-</span>
                            <CustomInput
                                isShowError={false}
                                isdisabled={isDisabled ? true : false}
                                placeholder="00"
                                errorMessage={errorMessage.ssnSecond}
                                value={formData.ssnSecond}
                                onClick={() => handleFieldClick('ssnSecond')}
                                type={ssnishoworhide?.ishidessn2 ? "password" : "text"}
                                togglePasswordVisibility={() => {
                                    setssnishoworhide(prevFormData => ({
                                        ...prevFormData,
                                        ishidessn2: !ssnishoworhide?.ishidessn2
                                    }))
                                }}
                            />
                            <span className='mx-1'>-</span>
                            <CustomInput
                                isShowError={false}
                                isdisabled={isDisabled ? true : false}
                                placeholder="0000"
                                errorMessage={errorMessage.ssnThird}
                                value={formData.ssnThird}
                                onClick={() => handleFieldClick('ssnThird')}
                                type={ssnishoworhide?.ishidessn3 ? "password" : "text"}
                                togglePasswordVisibility={() => {
                                    setssnishoworhide(prevFormData => ({
                                        ...prevFormData,
                                        ishidessn3: !ssnishoworhide?.ishidessn3
                                    }))
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`14. ${currentLang?.ApplicationForm?.Race} `}
                            type="text"
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Example_Race}
                            value={formData.race}
                            onClick={() => handleFieldClick('race')}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">15. {currentLang?.ApplicationForm?.Sex}</label>
                        <RadioButtonGroup
                            isShowError={false}
                            // label='23.Sex:'
                            options={GenderOptions}
                            selectedValue={formData?.Gender}
                            disabled={true}
                            handleChange={(e) => setFormData(prevData => ({
                                ...prevData,
                                Gender: e.target.value
                            }))}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">

                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`16. ${currentLang?.ApplicationForm?.The_person_who_can_Name}`}
                            type="text"
                            required={true}
                            errorMessage={errorMessage?.guardianName}
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Example_Mathew}
                            value={formData.guardianName}
                            onClick={() => handleFieldClick('guardianName')}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`17. ${currentLang?.ApplicationForm?.Telephone}`}
                            type="text"
                            placeholder="Eg: 9999999999"
                            value={formData.guardianTelephone}
                            onClick={() => handleFieldClick('guardianTelephone')}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            isdisabled={isDisabled ? true : false}
                            label={`18. ${currentLang?.ApplicationForm?.Address}`}
                            type="text"
                            required={true}
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Example_Address}
                            errorMessage={errorMessage.guardianAddress}
                            value={formData.guardianAddress}
                            onClick={() => handleFieldClick('guardianAddress')}
                        />
                    </div>
                </div>
            </>
        )
    }

    const rendermaritalStatusForm = () => {
        return (
            <>
                <div className="col-md-12">
                    <h4 className="app-form-title"> {currentLang?.ApplicationForm?.Marital_Status} </h4>
                </div>
                <div className="col-lg-9 col-md-12 col-sm-12 mb-1">
                    <div className="form-group">
                        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">19 {currentLang?.ApplicationForm?.Choose_your_Marital_status}<span className="mandatory">*</span></label>
                        <RadioButtonGroup
                            isShowError={true}
                            name='maritalStatus'
                            disabled={isDisabled ? true : false}
                            errorMessage={errorMessage}
                            options={MaritalStatusOptions}
                            selectedValue={formData?.maritalStatus}
                            handleChange={(e) => {
                                setFormData(prevData => ({
                                    ...prevData,
                                    maritalStatus: parseInt(e.target.value),
                                    spouseName: parseInt(e.target.value) !== 4 ? "" : prevData?.spouseName,
                                }));
                                setErrorMessage(prevData => ({
                                    ...prevData,
                                    maritalStatus: "",
                                    spouseName: (parseInt(e.target.value) === 4 && formData.spouseName?.trim()?.length == 0) ? currentLang?.ValidationSchema?.Form_Field_Required : "",
                                }));
                                setrequireFields(parseInt(e.target.value) === 4 ? [...requireFields, "spouseName"] : requireFields);
                            }}
                        />
                    </div>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            isdisabled={(isDisabled || formData?.maritalStatus != 4) ? true : false}
                            label={`20. ${currentLang?.ApplicationForm?.Spouse_Name}`}
                            type="text"
                            required={true}
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Example_John}
                            value={formData.spouseName}
                            errorMessage={errorMessage?.spouseName}
                            onClick={() => handleFieldClick('spouseName')}
                        />
                    </div>
                </div>
            </>
        )
    }

    const renderEmploymentform = () => {
        return (
            <>
                <div className="col-md-12">
                    <h4 className='app-form-title'>{currentLang?.ApplicationForm?.Employment}</h4>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 mb-1">
                    <div className="form-group">
                        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">21. {currentLang?.ApplicationForm?.Are_You_Employed}<span className="mandatory">*</span></label>
                        <RadioButtonGroup
                            isShowError={false}
                            //required={true}
                            // label='33. Are you employed (including self-employment, part-time work, or “odd jobs”)?'
                            disabled={isDisabled ? true : false}
                            name={'employed'}
                            errorMessage={errorMessage}
                            options={YesorNoOptions}
                            selectedValue={formData?.employed}
                            handleChange={(e) => {
                                setFormData(prevData => ({
                                    ...prevData,
                                    employed: parseInt(e.target.value),
                                    employerDetails: parseInt(e.target.value) === 1 ? prevData?.employerDetails : "",
                                    jobTitle: parseInt(e.target.value) === 1 ? prevData?.jobTitle : "",
                                    lengthOfJob: parseInt(e.target.value) === 1 ? prevData?.lengthOfJob : "",
                                }));
                                setErrorMessage({
                                    ...errorMessage,
                                    employed: "",
                                    employerDetails: (parseInt(e.target.value) === 1 && formData?.employerDetails?.trim()?.length == 0) ? currentLang?.ValidationSchema?.Form_Field_Required : "",
                                    jobTitle: (parseInt(e.target.value) === 1 && formData?.jobTitle?.trim()?.length == 0) ? currentLang?.ValidationSchema?.Form_Field_Required : "",
                                    lengthOfJob: (parseInt(e.target.value) === 1 && formData?.lengthOfJob?.trim()?.length == 0) ? currentLang?.ValidationSchema?.Form_Field_Required : "",
                                });
                                setrequireFields(parseInt(e.target.value) === 1 ? [...requireFields, "employerDetails", "jobTitle", "lengthOfJob"] : requireFields);

                            }}
                        />
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            label={`22. ${currentLang?.ApplicationForm?.If_Yes_Employer}`}
                            isdisabled={(isDisabled || formData?.employed != 1) ? true : false}
                            type="text"
                            className="form-control"
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Employee_Details}
                            value={formData?.employerDetails}
                            errorMessage={errorMessage?.employerDetails}
                            onClick={() => handleFieldClick('employerDetails')}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            label={`23. ${currentLang?.ApplicationForm?.Job_title}`}
                            isdisabled={(isDisabled || formData?.employed != 1) ? true : false}
                            type="text"
                            className="form-control"
                            placeholder={currentLang?.ApplicationFormPlaceholder?.Software_Developer}
                            value={formData?.jobTitle}
                            errorMessage={errorMessage?.jobTitle}
                            onClick={() => handleFieldClick('jobTitle')}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="form-group">
                            <CustomInput
                                isShowError={false}
                                label={`24. ${currentLang?.ApplicationForm?.Length_of_employment}`}
                                isdisabled={(isDisabled || formData?.employed != 1) ? true : false}
                                type="text"
                                className="form-control"
                                placeholder="Eg: 3"
                                value={formData?.lengthOfJob}
                                errorMessage={errorMessage?.lengthOfJob}
                                onClick={() => handleFieldClick('lengthOfJob')}
                            />
                        </div>
                        <div className="form-label col-form-label fs-5 form-label-custom-visible mb-0">
                            <p className='font-size-15 fw-400 mb-0 mt-3 ms-2'>{currentLang?.ApplicationForm?.Years}</p>
                        </div>
                    </div>


                </div>
            </>
        )
    }

    const renderIncomeForm = () => {
        return (
            <>
                <div className="col-md-12">
                    <h4 className="app-form-title">{currentLang?.ApplicationForm?.Income}</h4>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 mb-1">
                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">25. {currentLang?.ApplicationForm?.Net_Income}<span className="mandatory">*</span></label>
                    <div className='mandatory-gap'>
                        <div className="input-group display-inline">
                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
                                <span className="col-auto position-abs-doller">$</span>
                            </label>
                            <CustomInput
                                isShowError={false}
                                isdisabled={isDisabled ? true : false}
                                className="form-control"
                                required={true}
                                placeholder="Eg: 9999"
                                errorMessage={errorMessage?.netIncome}
                                value={formData.netIncome}
                                onClick={() => handleFieldClick('netIncome')}
                            // onChange={(e) => {
                            //     setFormData({ ...formData, netIncome: e.target.value });
                            //     setErrorMessage({ ...errorMessage, netIncomeType: e.target.value?.trim()?.length == 0 ? "" : currentLang?.ValidationSchema?.Form_Field_Required })
                            // }}
                            />
                        </div></div>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 mb-1">
                    <div className="form-group">
                        <RadioButtonGroup
                            isShowError={false}
                            label=""
                            errorMessage={errorMessage}
                            disabled={(isDisabled || formData.netIncome?.trim()?.length == 0) ? true : false}
                            options={IncomeTypeOptions}
                            name={'netIncomeType'}
                            selectedValue={formData.netIncomeType}
                            handleChange={(e) => {
                                setFormData({ ...formData, netIncomeType: parseInt(e.target.value) });
                                setErrorMessage({ ...errorMessage, netIncomeType: "" })
                            }}
                        />
                    </div>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 mb-1">
                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">26. {currentLang?.ApplicationForm?.If_incarcerated}<span className="mandatory">*</span></label>
                    <RadioButtonGroup
                        isShowError={false}
                        // label="40. If incarcerated, do you have income while in jail?"
                        // required={true}
                        disabled={isDisabled}
                        options={YesorNoOptions}
                        name={'incomeInJail'}
                        errorMessage={errorMessage}
                        selectedValue={formData.incomeInJail}
                        handleChange={(e) => {
                            setFormData(prevData => ({ ...formData, incomeInJail: parseInt(e.target.value), incomeInJailAmount: parseInt(e.target.value) !== 1 ? "" : prevData?.incomeInJailAmount }))
                            setErrorMessage({ ...errorMessage, incomeInJail: "", incomeInJailAmount: (parseInt(e.target.value) !== 1) ? "" : currentLang?.ValidationSchema?.Form_Field_Required });
                            setrequireFields(parseInt(e.target.value) === 1 ? [...requireFields, "incomeInJailAmount"] : requireFields);
                        }}
                    />
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 mb-1">
                    <CustomInput
                        isShowError={false}
                        label={`${currentLang?.ApplicationForm?.Amount} $`}
                        isdisabled={isDisabled || formData.incomeInJail != 1}
                        className="form-control"
                        placeholder="Eg: 9999"
                        value={formData.incomeInJailAmount}
                        errorMessage={errorMessage?.incomeInJailAmount}
                        onClick={() => handleFieldClick('incomeInJailAmount')}
                        onChange={(e) => {
                            setFormData({ ...formData, incomeInJailAmount: e.target.value });
                        }
                        }
                    />
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 mb-1">
                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">27. {currentLang?.ApplicationForm?.Do_You_Recive_Military}<span className="mandatory">*</span></label>
                    <RadioButtonGroup
                        isShowError={false}
                        //label="43. Do you receive: Military, VA, Social Security, SSI, TANF, Food Stamps, or Retirement benefits?"
                        disabled={isDisabled}
                        options={YesorNoOptions}
                        name={'receivesBenefits'}
                        //required={true}
                        errorMessage={errorMessage}
                        selectedValue={formData.receivesBenefits}
                        handleChange={(e) => {
                            setFormData(prevData => ({
                                ...formData, receivesBenefits: parseInt(e.target.value),
                                benefitsAmount: parseInt(e.target.value) !== 1 ? "" : prevData?.benefitsAmount
                            }));
                            setErrorMessage({ ...errorMessage, receivesBenefits: "", benefitsAmount: (parseInt(e.target.value) !== 1) ? "" : currentLang?.ValidationSchema?.Form_Field_Required });
                            setrequireFields(parseInt(e.target.value) === 1 ? [...requireFields, "benefitsAmount"] : requireFields);
                            setallFields(parseInt(e.target.value) !== 1 ? allFields : prevFields => prevFields.filter(x => x !== "receivesBenefits"));
                        }}
                    />
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 mb-1">
                    <CustomInput
                        isShowError={false}
                        label={`${currentLang?.ApplicationForm?.Amount} $`}
                        isdisabled={isDisabled || formData.receivesBenefits != 1}
                        className="form-control"
                        placeholder="Eg: 9999"
                        value={formData.benefitsAmount}
                        errorMessage={errorMessage?.benefitsAmount}
                        onClick={() => handleFieldClick('benefitsAmount')}
                    />
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 mb-1">
                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">28. {currentLang?.ApplicationForm?.Are_you_disabled}<span className="mandatory">*</span></label>
                    <RadioButtonGroup
                        isShowError={false}
                        // label="45. Are you disabled?"
                        disabled={isDisabled}
                        name={'isDisabled'}
                        //required={true}
                        errorMessage={errorMessage}
                        options={YesorNoOptions}
                        selectedValue={formData.isDisabled}
                        handleChange={(e) => {
                            setFormData(prevData => ({
                                ...formData, isDisabled: parseInt(e.target.value),
                                disabilityType: parseInt(e.target.value) !== 1 ? "" : prevData?.disabilityType
                            }));
                            setErrorMessage({ ...errorMessage, isDisabled: "", disabilityType: (parseInt(e.target.value) !== 1) ? "" : currentLang?.ValidationSchema?.Form_Field_Required });
                            setrequireFields(parseInt(e.target.value) === 1 ? [...requireFields, "disabilityType"] : requireFields);

                        }}
                    />
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 mb-1">
                    <CustomInput
                        isShowError={false}
                        label={currentLang?.ApplicationForm?.What_Type_Of_Disability}
                        isdisabled={isDisabled || formData.isDisabled != 1}
                        type="text"
                        errorMessage={errorMessage?.disabilityType}
                        className="form-control"
                        placeholder={currentLang?.ApplicationFormPlaceholder?.HandiCapped}
                        value={formData.disabilityType}
                        onClick={() => handleFieldClick('disabilityType')}
                        onChange={(e) => setFormData({ ...formData, disabilityType: e.target.value })}
                    />
                </div>
            </>
        )
    }
    const renderpropationandunusualForm = () => {
        return (
            <>

                <div className="col-lg-12 col-md-12 col-sm-12 mb-1">
                    <div className="form-group" style={{ overflow: 'hidden', background: '#efefef', padding: '16px 10px' }}>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible" >
                                    29. {currentLang?.ApplicationForm?.If_you} <span className="letter-important req-frm-subtitle">{currentLang?.ApplicationForm?.DO_NOT}</span> {currentLang?.ApplicationForm?.Desire_the_services_of_court_appointed_counsel}
                                </label>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                                <div className="form-group">
                                    <SignatureField
                                        isshowUpdatebtn={isshowUpdatebtn}
                                        disabled={isDisabled}
                                        required={false}
                                        label={currentLang?.ApplicationForm?.SIGNATURE}
                                        existingSignature={formData.signature}
                                        onSignatureSubmit={(dataURL) => setFormData({ ...formData, signature: dataURL })}
                                        errorMessage={errorMessage?.signature}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible" >{currentLang?.ApplicationForm?.Date}</label>
                                    <div className="d-inline-flex align-items-center">
                                        <CustomInput
                                            isShowError={false}
                                            isdisabled={true}
                                            type="text"
                                            value={formData?.applicationMonth}
                                        />
                                        <span className='mx-1'>/</span>
                                        <CustomInput
                                            isShowError={false}
                                            isdisabled={true}
                                            type="text"
                                            value={formData?.applicationDay}
                                        />
                                        <span className='mx-1'>/</span>
                                        <CustomInput
                                            isShowError={false}
                                            isdisabled={true}
                                            type="text"
                                            value={formData?.applicationYear}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        )
    }

    const rendernoticeandVerificationform = () => {
        return (
            <>
                <div className="col-md-12">
                    <label className="form-SubTitle fw-bold">{currentLang?.ApplicationForm?.NOTICE_OF_APPLICATION_FEE_AND_ATTORNEY_FEE}</label>
                </div>
                <div className="col-md-12">
                    <p className="form-label col-form-label  w-100 fs-5 form-label-custom-visible fw-bold">
                        {currentLang?.ApplicationForm?.Georgia_law}
                    </p>
                </div>
                <div className="col-md-12">
                    <label className="form-SubTitle fw-bold">{currentLang?.ApplicationForm?.VERIFICATION_AND_RELEASE}</label>
                </div>
                <div className="col-md-12">
                    <p className="form-label col-form-label  w-100 fs-5 form-label-custom-visible fw-bold">
                        {currentLang?.ApplicationForm?.Application_Content}                        </p>
                </div>
                <div className="ms-1">
                    <div className="col-md-12 font-size-15 mb-1 fw-bold">


                        {currentLang?.ApplicationForm?.This_Application_is_for} 30 <span className="mandatory">*</span>


                        <div className='width-200 inline-flex fw-400 me-2 ms-2'>
                            <CustomInput
                                isShowError={false}
                                className="form-control"
                                value={formData?.caseTotal}
                                errorMessage={errorMessage?.caseTotal}
                                isdisabled={isDisabled}
                                placeholder="Eg: 7895"
                                onClick={() => handleFieldClick('caseTotal')}
                            />
                        </div>

                        {currentLang?.ApplicationForm?.I_understand_that_I_will_be_assessed_an_application_fee}

                    </div>

                </div>
                <div className="inputtypecheckbox col-md-12 ms-1 fw-bold">
                    <CheckBoxInput
                        required={true}
                        label={currentLang?.ApplicationForm?.ACKNOWLEDGEMENT}
                        name="acknowledgeMent"
                        id="acknowledgeMent"
                        handleClick={(e) => {
                            setFormData(prevData => ({
                                ...prevData,
                                acknowledgeMent: e.target.checked
                            }));
                            setErrorMessage({ ...errorMessage, acknowledgeMent: e.target.checked ? '' : "This filed is Required" })
                        }}
                        disabled={isDisabled}
                        errorMessage={errorMessage}
                        checked={formData?.acknowledgeMent}
                    />
                </div>
                <div className='row col-md-12'>
                    <div className="col-lg-6 col-md-6 col-sm-12 ">
                        <div className="mt-5">
                            <div className="d-flex align-items-center">
                                <label className="form-label no-wrap col-form-label fs-5 form-label-custom-visible mb-0 me-1">
                                    31.  {currentLang?.ApplicationForm?.This}
                                </label>
                                <CustomInput
                                    isShowError={false}
                                    isdisabled={true}
                                    className="form-control"
                                    value={`${new Date().getDate()} th`}
                                />

                                <span className="form-label no-wrap col-form-label fs-5 form-label-custom-visible mb-0 ms-2 me-2 fw-bold">{currentLang?.ApplicationForm?.day_of}</span>
                                <CustomInput
                                    isShowError={false}
                                    isdisabled={true}
                                    className="form-control"
                                    value={new Date().toLocaleString('en-US', { month: 'short' })} // Month in short format (e.g., "Oct")
                                />
                                <span className="ms-2 me-2 font-size-15">,</span>
                                <CustomInput
                                    isShowError={false}
                                    isdisabled={true}
                                    className="form-control"
                                    value={new Date().getFullYear().toString()}
                                />

                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                        <SignatureField
                            disabled={isDisabled}
                            required={true}
                            label={`32. ${currentLang?.ApplicationForm?.SIGNATURE}`}
                            existingSignature={formData.pdsInmateSignature}
                            onSignatureSubmit={(dataURL) => {
                                setFormData({ ...formData, pdsInmateSignature: dataURL });
                                setErrorMessage({ ...errorMessage, pdsInmateSignature: dataURL ? '' : "This filed is Required" });
                            }}
                            errorMessage={errorMessage?.pdsInmateSignature}
                            isshowUpdatebtn={isshowUpdatebtn}
                        />

                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            label={`33. ${currentLang?.ApplicationForm?.Print_Name} `}
                            isdisabled={true}
                            className="form-control"
                            value={storedloginResponse?.InmateFullName}
                            placeholder={currentLang?.ApplicationFormPlaceholder?.John_Peter}
                            onClick={() => handleFieldClick('submitterName')}
                        />
                        <div className="form-group">
                            <b className="form-label col-form-label fs-5 form-label-custom-visible mb-0 me-2 fw-bold" >{currentLang?.ApplicationForm?.ASSISTANCE}</b>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="form-group">
                        <CustomInput
                            isShowError={false}
                            label={`34. ${currentLang?.ApplicationForm?.Name}`}
                            isdisabled={isDisabled ? true : false}
                            type="text"
                            className="form-control"
                            value={formData?.assistanceName}
                            placeholder={currentLang?.ApplicationFormPlaceholder?.John_Peter}
                            onClick={() => handleFieldClick('assistanceName')}
                        />
                    </div>
                </div>
                <div className='row col-md-12'>
                    <div className="col-md-6">
                        <div className="form-group">
                            <CustomInput
                                isShowError={false}
                                label={`35. ${currentLang?.ApplicationForm?.Phone}`}
                                isdisabled={isDisabled ? true : false}
                                type="text"
                                className="form-control"
                                value={formData?.assistancePhone}
                                placeholder="Eg: 0123456789"
                                onClick={() => handleFieldClick('assistancePhone')}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                        <div className="form-group">
                            <CustomInput
                                isShowError={false}
                                label={`36. ${currentLang?.ApplicationForm?.Address}`}
                                isdisabled={isDisabled ? true : false}
                                type="text"
                                className="form-control"
                                value={formData?.assistanceAddress}
                                placeholder={currentLang?.ApplicationFormPlaceholder?.Address}
                                onClick={() => handleFieldClick('assistanceAddress')}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            {isloading && <Loader />}
            {isshowNotice && <NotesModal notesData={notesData} onClose={() => { setisshowNotice(false) }} />}
            <div className="form-row">
                {showPopup && (
                    <CustomModal
                        color={modalContentColor}
                        content={modalContent}
                        onOkClick={() => {
                            if (!issubmit) {
                                setShowPopup(false);
                            } else {
                                setissubmit(false);
                                handleBack();
                            }
                        }}
                    />
                )}
                {showBoard && (
                    <div >
                        <CustomKeyboard
                            currentField={currentField}
                            setCurrentField={setCurrentField}
                            inputs={formData}
                            setShowBoard={setShowBoard}
                            setInputs={setFormData}
                            fields={keyboardFields}
                            allFields={allFields}
                            requireFields={requireFields}
                            setrequireFields={setrequireFields}
                            setErrorMessage={setErrorMessage}
                            type="Multiple"
                            setValues={setValues}
                            handleCancel={() => { setFormData(values) }}
                            placeholderList={placeholder}
                            isTabKey={false}
                            isEnterKey={false}
                        />
                    </div>
                )}
                <div className="row border-bottom mb-2 w-100 d-flex align-items-center ">
                    <div className="col-md-4">
                        <div className="form-group mb-1">
                            <img src={logogeorgia} alt="Logo" style={{ width: '50%' }} />
                        </div>
                    </div>
                    <div className="col-md-8">
                        <h3 className='fw-700 d-flex'>{currentLang?.ApplicationForm?.Header}</h3>
                    </div>
                </div>
                {/* Application Date */}
                <div className="row d-flex flex-wrap w-100 justify-content-between ">

                    {renderPublicDefenderForm()}
                    {rendertelephoneForm()}
                    {rendermaritalStatusForm()}
                    {renderEmploymentform()}
                    {renderIncomeForm()}
                    {renderpropationandunusualForm()}
                    {rendernoticeandVerificationform()}

                </div>

            </div>
            <div className='col-md-12 plr-40 mb-3'>
                {!isEdit && <div className="d-flex justify-content-end gap-3 mt-30">
                    <Button label={currentLang?.Buttons?.Submit} status="primary" type="submit" disabled={issubmit} isLoading={issubmit} onClick={() => { handleSubmit() }} />
                </div>}
                {isshowUpdatebtn && <div className="d-flex justify-content-end gap-3">
                    <Button label={currentLang?.Buttons?.Update} status="primary" type="submit" disabled={issubmit} isLoading={issubmit} onClick={() => { handleSubmit() }} />
                </div>}
            </div>

        </>
    );
};

export default memo(PublicDefenderServiceForm);

